module.exports = __webpack_public_path__ + "static/img/14b.ef0a515.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/14b.jpg
// module id = sLZB
// module chunks = 0